module.exports = __webpack_public_path__ + "static/awards-logo0-56d6c0d85b21baac7a9489cf985bdd42.png";